import { PortalName } from "@/config";

export const Variables = {
  links: {
    transparency: "",
    PMA: "",
  },
  portalName: "Prefeitura Municipal de Laranja da Terra",
  portalSite: "www.prefeitura.es.gov.br",
  address: "",
  cityHallName: "Laranja da Terra",
  htmlTextLaw: `
			Unidade/setor responsável: Controladoria Interna
			<br />
			Responsável: Bruna Pio Martins
			<br /><br />
			O cidadão pode apresentar pedido de acesso à informação por meio do e-SIC, sem necessidade de justificativa, bastando descrever objetivamente a informação desejada. O prazo para resposta é de até 20 (vinte) dias, prorrogável por mais 10 (dez) dias . Caso a resposta não seja satisfatória, é possível interpor recurso no prazo de 10 (dez) dias, a ser examinado, em primeira instância, por autoridade hierarquicamente superior à que emitiu a decisão inicial, e, se necessário, por instâncias superiores, quais sejam a Controladoria Interna e Gabinete do Prefeito. O prazo para resposta ao recurso é de 5 (cinco) dias, prorrogável por igual período. As autoridades competentes para análise dos pedidos e recursos atuam em conformidade com os princípios da transparência e da legalidade.
			<br /><br />
			A 
			<a
				target="_blank"
				href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm"
				>Lei Federal nº 12.527/2011</a
			>
			regulamentou o direito constitucional de acesso a informação previsto
			no inciso XXXIII do art. 5o, no inciso II do 3º do art. 37 e no 2º
			do art. 216 da Constituição Federal. Neste canal qualquer pessoa
			física ou jurídica poderá encaminhar pedidos de acesso à qualquer
			informação pública produzida ou sob a guarda da ${PortalName}.
			<br /><br />
			Ressaltamos que não compartilhamos os dados do requerente com os órgãos municipais.
	`,
};
